export var colorScheme = {
  LIGHT: 'light',
  DARK: 'dark'
};